import React from 'react'
import { Icons } from '../../Shared/Icons'
import { Spinner } from '../../Shared/Spinner/Spinner'
import styles from './styles.module.scss'

interface AiDraftSuccessScreenProps {
  message: string
  subtitle: string
  isLoading?: boolean
}

const AiDraftSuccessScreen: React.FC<AiDraftSuccessScreenProps> = ({ message, subtitle, isLoading = false }) => {
  return (
    <div className={styles.successScreen} role="status" aria-live="polite">
      <div className={styles.checkmarkContainer}>
        <div className={styles.checkmark} aria-hidden="true">
          <Icons.CheckCircle />
        </div>
      </div>
      <div className={styles.messageContainer}>
        <h2 className={styles.message}>{message}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
        {isLoading && <Spinner classNames={styles.loadingSpinner} isLoading />}
      </div>
    </div>
  )
}

export default AiDraftSuccessScreen
